/**
 * Reconnaît un `ObjectId` quelle que soit la copie de `bson` qui l'a construit.
 *
 * Le pilote MongoDB est publié en CommonJS et charge `bson.cjs` ; le code ESM du dépôt charge
 * `bson.mjs`. Même version, deux classes : un `ObjectId` relu en base n'est pas `instanceof` celui
 * du dépôt. Un test `instanceof` rejetterait alors un `tenant_id` légitime relu en base comme une
 * tentative d'accès inter-tenant. La marque `_bsontype` est le moyen que `bson` documente.
 */
export function isObjectId(value) {
    return (typeof value === 'object' &&
        value !== null &&
        value._bsontype === 'ObjectId' &&
        typeof value.toHexString === 'function');
}
/** Égalité de deux identifiants, par leur valeur et jamais par leur classe. */
export function sameObjectId(a, b) {
    return isObjectId(a) && isObjectId(b) && a.toHexString() === b.toHexString();
}
//# sourceMappingURL=object-id.js.map